(function () {
  function step(track) {
    var card = track.querySelector(".bm-ugc__card");
    if (!card) return track.clientWidth;
    var gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
    return card.getBoundingClientRect().width + gap;
  }

  function updateArrows(track, prev, next) {
    var max = track.scrollWidth - track.clientWidth;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max - 2;
  }

  function setSoundState(button, on) {
    button.setAttribute("aria-pressed", on ? "true" : "false");
    button.setAttribute("aria-label", on ? "Mute" : "Unmute");
  }

  function init(root) {
    if (!root || root.dataset.bmUgcReady === "true") return;
    root.dataset.bmUgcReady = "true";

    var track = root.querySelector(".bm-ugc__track");
    var prev = root.querySelector(".bm-ugc__arrow--prev");
    var next = root.querySelector(".bm-ugc__arrow--next");
    if (!track || !prev || !next) return;

    prev.addEventListener("click", function () {
      track.scrollBy({ left: -step(track), behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      track.scrollBy({ left: step(track), behavior: "smooth" });
    });
    track.addEventListener("scroll", function () {
      updateArrows(track, prev, next);
    }, { passive: true });
    window.addEventListener("resize", function () {
      updateArrows(track, prev, next);
    });
    updateArrows(track, prev, next);

    root.querySelectorAll(".bm-ugc__video").forEach(function (video) {
      video.muted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      var play = video.play();
      if (play && play.catch) play.catch(function () {});
    });

    root.querySelectorAll(".bm-ugc__sound").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.stopPropagation();
        var video = button.parentElement.querySelector(".bm-ugc__video");
        if (!video) return;
        var turnOn = video.muted;

        root.querySelectorAll(".bm-ugc__video").forEach(function (other) {
          other.muted = true;
        });
        root.querySelectorAll(".bm-ugc__sound").forEach(function (other) {
          setSoundState(other, false);
        });

        if (turnOn) {
          video.muted = false;
          setSoundState(button, true);
          var play = video.play();
          if (play && play.catch) play.catch(function () {});
        }
      });
    });

    bindModal(root);
  }

  function cartUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + "cart/add.js";
    }
    return "/cart/add.js";
  }

  function readProducts(card) {
    var node = card.querySelector(".bm-ugc__shop");
    if (!node) return [];
    try {
      var data = JSON.parse(node.textContent);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  }

  function copySources(card, to) {
    var opener = card.querySelector("[data-bm-ugc-open]");
    var highRes = opener && opener.getAttribute("data-bm-ugc-src");
    var from = card.querySelector(".bm-ugc__video");
    to.pause();
    to.removeAttribute("src");
    while (to.firstChild) to.removeChild(to.firstChild);
    if (highRes) {
      to.src = highRes;
    } else if (from) {
      from.querySelectorAll("source").forEach(function (source) {
        to.appendChild(source.cloneNode());
      });
      if (!to.querySelector("source")) {
        var src = from.currentSrc || from.getAttribute("src");
        if (src) to.src = src;
      }
    }
    to.preload = "auto";
    to.muted = true;
    to.loop = true;
    to.playsInline = true;
    to.load();
  }

  function fitStage(video) {
    var stage = video.closest(".bm-ugc-modal__stage");
    if (!stage || !video.videoWidth || !video.videoHeight) return;
    stage.style.aspectRatio = video.videoWidth + " / " + video.videoHeight;
  }

  function bindModal(root) {
    var modal = root.querySelector("[data-bm-ugc-modal]");
    var cards = root.querySelectorAll(".bm-ugc__card");
    if (!modal || !cards.length) return;

    var video = modal.querySelector("[data-bm-ugc-video]");
    var list = modal.querySelector("[data-bm-ugc-list]");
    var addAll = modal.querySelector("[data-bm-ugc-add-all]");
    var progressBar = modal.querySelector("[data-bm-ugc-progress-bar]");
    var progress = modal.querySelector("[data-bm-ugc-progress]");
    var pauseBtn = modal.querySelector("[data-bm-ugc-pause]");
    var muteBtn = modal.querySelector("[data-bm-ugc-mute]");
    var prevBtn = modal.querySelector("[data-bm-ugc-prev]");
    var nextBtn = modal.querySelector("[data-bm-ugc-next]");
    var addLabel = modal.getAttribute("data-add-label") || "Add to Cart";
    var soldOutLabel = modal.getAttribute("data-sold-out-label") || "Sold out";
    var index = 0;
    var opener = null;
    var ids = [];
    var modalHome = modal.parentNode;

    function setPauseState() {
      var paused = video.paused;
      pauseBtn.classList.toggle("is-paused", paused);
      pauseBtn.setAttribute("aria-label", paused ? "Play" : "Pause");
    }

    function setMuteState() {
      var on = !video.muted;
      muteBtn.setAttribute("aria-pressed", on ? "true" : "false");
      muteBtn.setAttribute("aria-label", on ? "Mute" : "Unmute");
    }

    function renderProducts(products) {
      list.innerHTML = "";
      ids = [];
      products.forEach(function (product) {
        if (!product || !product.variantId) return;
        var row = document.createElement("article");
        row.className = "bm-ugc-modal__item";

        var thumbLink = document.createElement("a");
        thumbLink.className = "bm-ugc-modal__thumb-link";
        thumbLink.href = product.url || "#";
        if (product.image) {
          var img = document.createElement("img");
          img.className = "bm-ugc-modal__thumb";
          img.src = product.image;
          img.alt = "";
          img.width = 64;
          img.height = 64;
          thumbLink.appendChild(img);
        }
        row.appendChild(thumbLink);

        var meta = document.createElement("div");
        meta.className = "bm-ugc-modal__meta";
        var name = document.createElement("a");
        name.className = "bm-ugc-modal__name";
        name.href = product.url || "#";
        name.textContent = product.title || "";
        var price = document.createElement("p");
        price.className = "bm-ugc-modal__price";
        if (product.compare) {
          var compare = document.createElement("s");
          compare.textContent = product.compare;
          price.appendChild(compare);
        }
        var current = document.createElement("span");
        current.textContent = product.price || "";
        price.appendChild(current);
        meta.appendChild(name);
        meta.appendChild(price);
        row.appendChild(meta);

        var button = document.createElement("button");
        button.className = "bm-ugc-modal__add";
        button.type = "button";
        if (product.available) {
          button.textContent = addLabel;
          button.addEventListener("click", function () {
            addVariants([product.variantId], button, addLabel);
          });
          ids.push(product.variantId);
        } else {
          button.textContent = soldOutLabel;
          button.disabled = true;
        }
        row.appendChild(button);
        list.appendChild(row);
      });
      addAll.hidden = ids.length === 0;
    }

    var panel = modal.querySelector(".bm-ugc-modal__panel");
    var sheetOpen = false;

    var sheetBtn = modal.querySelector("[data-bm-ugc-sheet]");

    function mobileSheet() {
      return window.matchMedia("(max-width: 900px)").matches;
    }

    function syncSheetButton() {
      if (!sheetBtn) return;
      sheetBtn.setAttribute("aria-expanded", sheetOpen ? "true" : "false");
      sheetBtn.setAttribute("aria-label", sheetOpen ? "Hide products" : "Show products");
    }

    function fitMobilePanel() {
      var head = modal.querySelector(".bm-ugc-modal__head");
      var first = list.querySelector(".bm-ugc-modal__item");
      if (!panel) return;
      if (!mobileSheet() || sheetOpen || !head) {
        if (!sheetOpen) panel.style.maxHeight = "";
        return;
      }
      var pad = parseFloat(window.getComputedStyle(panel).paddingBottom) || 0;
      var itemHeight = first ? first.offsetHeight : 0;
      panel.style.maxHeight = head.offsetHeight + itemHeight + pad + "px";
    }

    function collapseSheet() {
      sheetOpen = false;
      if (panel) {
        panel.classList.remove("is-expanded");
        panel.scrollTop = 0;
      }
      syncSheetButton();
      fitMobilePanel();
    }

    function expandSheet() {
      if (!panel || sheetOpen || !mobileSheet()) return;
      sheetOpen = true;
      panel.classList.add("is-expanded");
      panel.style.maxHeight = "";
      syncSheetButton();
    }

    function show(nextIndex) {
      var card = cards[nextIndex];
      var source = card && card.querySelector(".bm-ugc__video");
      if (!card || !source) return;
      index = nextIndex;
      collapseSheet();
      copySources(card, video);
      fitStage(video);
      renderProducts(readProducts(card));
      var play = video.play();
      if (play && play.catch) play.catch(function () {});
      setPauseState();
      setMuteState();
      if (progressBar) progressBar.style.width = "0%";
      prevBtn.hidden = cards.length < 2;
      nextBtn.hidden = cards.length < 2;
      fitMobilePanel();
    }

    function openAt(nextIndex, trigger) {
      opener = trigger || document.activeElement;
      root.querySelectorAll(".bm-ugc__video").forEach(function (item) {
        item.pause();
      });
      if (modal.parentNode !== document.body) document.body.appendChild(modal);
      modal.hidden = false;
      document.documentElement.classList.add("bm-ugc-modal-open");
      show(nextIndex);
      var closeBtn = modal.querySelector(".bm-ugc-modal__close");
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      collapseSheet();
      modal.hidden = true;
      document.documentElement.classList.remove("bm-ugc-modal-open");
      video.pause();
      root.querySelectorAll(".bm-ugc__video").forEach(function (item) {
        item.muted = true;
        var play = item.play();
        if (play && play.catch) play.catch(function () {});
      });
      root.querySelectorAll(".bm-ugc__sound").forEach(function (button) {
        setSoundState(button, false);
      });
      if (opener && opener.focus) opener.focus();
      if (modalHome && modal.parentNode === document.body) modalHome.appendChild(modal);
    }

    function addVariants(variantIds, button, label) {
      if (!variantIds.length) return;
      button.disabled = true;
      button.textContent = "Adding...";

      var items = variantIds.map(function (id) {
        return { id: id, quantity: 1 };
      });

      var finish = function () {
        button.textContent = "Added";
        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = label;
        }, 1200);
      };

      var fail = function () {
        button.disabled = false;
        button.textContent = "Try again";
        window.setTimeout(function () {
          button.textContent = label;
        }, 1400);
      };

      if (window.FoxTheme && FoxTheme.routes && FoxTheme.pubsub && FoxTheme.utils) {
        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:grouped-sections", {
            bubbles: true,
            detail: { sections: sectionsToBundle }
          })
        );
        var config = FoxTheme.utils.fetchConfig("javascript");
        config.body = JSON.stringify({
          items: items,
          sections: sectionsToBundle,
          section_url: window.location.pathname
        });
        fetch(FoxTheme.routes.cart_add_url, config)
          .then(function (response) {
            return response.json();
          })
          .then(function (parsed) {
            if (parsed.status) throw new Error(parsed.description || "cart");
            return fetch(FoxTheme.routes.cart_url, FoxTheme.utils.fetchConfig()).then(function (response) {
              return response.json();
            }).then(function (cartJson) {
              cartJson.sections = parsed.sections;
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
              var drawer = document.querySelector("cart-drawer");
              if (drawer && drawer.show) drawer.show(button);
              finish();
            });
          })
          .catch(fail);
        return;
      }

      fetch(cartUrl(), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error("cart");
          document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
          finish();
        })
        .catch(fail);
    }

    root.querySelectorAll("[data-bm-ugc-open]").forEach(function (button) {
      button.addEventListener("click", function () {
        var card = button.closest(".bm-ugc__card");
        var nextIndex = Array.prototype.indexOf.call(cards, card);
        if (nextIndex < 0) return;
        openAt(nextIndex, button);
      });
    });

    modal.addEventListener("click", function (event) {
      var inDialog = event.target.closest(".bm-ugc-modal__dialog");
      if (inDialog && !event.target.closest("[data-bm-ugc-close]")) return;
      close();
    });

    prevBtn.addEventListener("click", function () {
      show((index - 1 + cards.length) % cards.length);
    });
    nextBtn.addEventListener("click", function () {
      show((index + 1) % cards.length);
    });

    pauseBtn.addEventListener("click", function () {
      if (video.paused) {
        var play = video.play();
        if (play && play.catch) play.catch(function () {});
      } else {
        video.pause();
      }
      setPauseState();
    });

    muteBtn.addEventListener("click", function () {
      video.muted = !video.muted;
      if (!video.muted) {
        var play = video.play();
        if (play && play.catch) play.catch(function () {});
      }
      setMuteState();
    });

    progress.addEventListener("click", function (event) {
      if (!video.duration) return;
      var rect = progress.getBoundingClientRect();
      var ratio = (event.clientX - rect.left) / rect.width;
      video.currentTime = Math.max(0, Math.min(video.duration, ratio * video.duration));
    });

    video.addEventListener("loadedmetadata", function () {
      fitStage(video);
    });
    video.addEventListener("timeupdate", function () {
      if (!video.duration || !progressBar) return;
      progressBar.style.width = (video.currentTime / video.duration) * 100 + "%";
    });
    video.addEventListener("play", setPauseState);
    video.addEventListener("pause", setPauseState);

    addAll.addEventListener("click", function () {
      addVariants(ids.slice(), addAll, addAll.getAttribute("data-label") || addAll.textContent);
    });

    document.addEventListener("keydown", function (event) {
      if (modal.hidden || event.key !== "Escape") return;
      close();
    });

    window.addEventListener("resize", function () {
      if (modal.hidden) return;
      fitMobilePanel();
    });

    if (panel) {
      var sheetHead = modal.querySelector(".bm-ugc-modal__head");
      var sheetStartY = 0;
      var sheetStartScroll = 0;
      var sheetDragged = false;
      panel.addEventListener("touchstart", function (event) {
        if (!event.touches.length) return;
        sheetStartY = event.touches[0].clientY;
        sheetStartScroll = panel.scrollTop;
        sheetDragged = false;
      }, { passive: true });
      panel.addEventListener("touchmove", function (event) {
        if (!event.touches.length || !mobileSheet()) return;
        var delta = sheetStartY - event.touches[0].clientY;
        if (delta > 28 && !sheetOpen) {
          sheetDragged = true;
          expandSheet();
        } else if (delta < -36 && sheetOpen && sheetStartScroll <= 0) {
          sheetDragged = true;
          collapseSheet();
        }
      }, { passive: true });
      if (sheetHead) {
        sheetHead.addEventListener("click", function () {
          if (!mobileSheet()) return;
          if (sheetDragged) {
            sheetDragged = false;
            return;
          }
          if (sheetOpen) collapseSheet();
          else expandSheet();
        });
      }
    }
  }

  function scan() {
    document.querySelectorAll(".bm-ugc").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector(".bm-ugc");
    if (root) init(root);
  });
})();
